import { render, staticRenderFns } from "./DesignWorldCalendarEdit.vue?vue&type=template&id=2bc8a08d&scoped=true&"
import script from "./DesignWorldCalendarEdit.vue?vue&type=script&lang=js&"
export * from "./DesignWorldCalendarEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8a08d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VSpacer})
